import * as Yup from "yup";
import dayjs from "dayjs";

export const validateRowSchema = Yup.object().shape({
    itemId: Yup
        .string()
        .required("Required"),
    name: Yup
        .string()
        .required("Required"),
    description: Yup
        .string()
        .required("Required"),
    qty: Yup
        .number()
        .typeError("Number Only")
        .required("Required")
        // .test(
        //     "is-positive",
        //     "Please enter a positive number",
        //     (value) => value >= 0 && 1 / value !== -Infinity),
})

export const validationSchema = Yup.object({
    // description: yup
    //     .string()
    //     .required('Description is required'), 
    documentDate: Yup
        // .string()
        .date("Invalid")
        .required("Required")
        .typeError("Invalid"),
    locationId: Yup
        .string()
        .required("Required"),
    rows: Yup.array().of(validateRowSchema)
})

export const initialRowValues = {
    docItemId: 0,
    itemId: "",
    name: "",
    code: "",
    decription: "",
    qty: 0,
    uonName: "",
    uomId: "",
    price: "",
    scanType: false
}

export const initialValues = {
    documentDate: dayjs(),
    rows: [initialRowValues],
    totalqty: "0",
    locationId: "",
    locationName: "",
    toLocationId: "",
    toLocationName: ""
}
